import { routerMiddleware as createRouterMiddleware } from "connected-react-router";
import { history } from "./routerHistory";


const routerMiddleware = createRouterMiddleware(history);

export default routerMiddleware
